import React from "react";
import { FaWhatsapp } from "react-icons/fa";

const WHATSAPP_NUMBER = "919450254374";
const DEFAULT_MESSAGE = "Hi! I'm interested in your photo editing services.";

const WhatsAppButton = () => {
  const href = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(
    DEFAULT_MESSAGE
  )}`;

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className="whatsapp-float-btn"
      aria-label="Chat with us on WhatsApp"
    >
      <span className="whatsapp-float-ping" />
      <FaWhatsapp />
    </a>
  );
};

export default WhatsAppButton;
